import type { DeliveryMode } from '../../store/structureDefinitions/storeState';

/* eslint-disable no-console */
import { appConfig } from '../../../../appConfig';
import { Cookies } from '../../../../utility/cookies';

const STORE_CONTEXT_COOKIE = 'coop-storeContext';
let storeContextCache: StoreContextCookie | undefined;

interface StoreContextCookie {
    deliveryMode?: DeliveryMode;
    productionUnitId: string;
    storeName?: string | null;
    pickupPointId: string | null;
    /** This is ONLY for display, shouldnt matter for storeselections */
    zipCode?: string;
}

const decodeStoreContextCookie = (cookie: string) => {
    let decodedCookie: string;

    try {
        decodedCookie = decodeURIComponent(atob(cookie));
    } catch {
        // old decode with escape that was used to decode backend cookies
        decodedCookie = decodeURIComponent(escape(atob(cookie)));
    }

    return decodedCookie;
};

const storeContext = {
    get: (): StoreContextCookie => {
        const storeContextCookie = Cookies.read(STORE_CONTEXT_COOKIE);
        if (storeContextCookie) {
            try {
                const decodedCookie = decodeStoreContextCookie(storeContextCookie);
                const storeContextSettings = JSON.parse(decodedCookie) as StoreContextCookie;
                return storeContextSettings;
                // eslint-disable-next-line no-empty
            } catch {}
        }

        return storeContext.getDefaultStoreContext();
    },

    getCached() {
        if (!storeContextCache) {
            storeContextCache = storeContext.get();
        }

        return storeContextCache;
    },
    /** Please use carefully! */
    set: (context: StoreContextCookie) => {
        const storeContextCookie: StoreContextCookie = {
            productionUnitId: context.productionUnitId,
            pickupPointId: context.pickupPointId || null,
            storeName: context.storeName || null,
            deliveryMode: context.deliveryMode,
            zipCode: context.zipCode,
        };
        Cookies.create(STORE_CONTEXT_COOKIE, btoa(JSON.stringify(storeContextCookie)), 90);
        storeContextCache = storeContextCookie;
    },

    getDefaultStoreContext: () => {
        const context: StoreContextCookie = {
            productionUnitId: appConfig.coopSettings.ecommerce.defaultStoreId,
            pickupPointId: null,
            storeName: null,
            deliveryMode: undefined,
            zipCode: undefined,
        };
        return context;
    },
};

export default storeContext;
